import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';
import { Customer } from './customer.model';

export class CustomerDetails extends Model {
  @Type(() => Customer)
  @Expose()
  customer: Customer = new Customer();
  @Expose() totalContractsCount: number;
  @Expose() totalReceiversCount: number;
  @Expose() totalUsersCount: number;
  @Expose() totalFleetContractsCount: number;
  @Expose() totalSpecificFleetsCount: number;
  @Expose() totalMyCustomersCount: number;
}
